export default __webpack_public_path__ + "static/media/login.e9633564.svg";